$(function() {
	var formContainer = $('.nf-form-cont');
	if (!formContainer.length)
		return;

	jQuery(document).ready(function() {
		var loadOrder = 0;
		new(Marionette.Object.extend({
			initialize: function() {
				this.listenTo(Backbone.Radio.channel('pikaday'), 'init', this.modifyDatepicker);
			},
			modifyDatepicker: function(dateObject, fieldModel) {
				var i = $('<i class="calendar"></i>');
				var picker = dateObject.pikaday;
				var input = $(dateObject.element).next();
				input.attr('order', loadOrder);
				input.data('picker', picker);
				var wrapper = input.parent();

				wrapper.append(i);
				wrapper.click(function() {
					picker.show();
				});

				loadOrder += 1;
			}
		}));
	});

	$window.load(function() {
		if ($('#nf-form-3-cont').length) {
			var form = $('#nf-form-3-cont');
			var inputs = form.find('input.pikaday__display');
			var errorElements = [];
			var timestamps = {0: null, 1: null, 2: null, 3: null};

			inputs.each(function() {
				errorElements.push($(this).parents('.date-container').find('.nf-error-wrap'));
			});

			inputs.change(function() {
				var date = $(this).val();
				var order = $(this).attr('order');
				var timestamp = moment(date, "dddd, MMMM DD YYYY").unix();
				timestamps[order] = timestamp;
				validateDates(order);
			});

			var validateDates = function(whichChanged) {
				var functionStart = timestamps[0];
				var functionEnd = timestamps[1];

				var arrivalStart = timestamps[2];
				var arrivalEnd = timestamps[3];

				if (functionStart && functionEnd) {
					if (functionStart >= functionEnd) {
						errorElements[whichChanged].html($('<div class="nf-error-msg date-error">' + 'First date should be before last date.' + '</div>'));
					} else if (functionEnd <= functionStart) {
						errorElements[whichChanged].html($('<div class="nf-error-msg date-error">' + 'Last date should be after first date.' + '</div>'));
					} else {
						$(errorElements.slice(0,2)).each(function() {
							$(this).find('.date-error').remove();
						});
					}
				}


				if (arrivalStart && arrivalEnd) {
					if (arrivalStart >= arrivalEnd) {
						errorElements[whichChanged].html($('<div class="nf-error-msg date-error">' + 'First date should be before last date.' + '</div>'));
					} else if (arrivalEnd <= arrivalStart) {
						errorElements[whichChanged].html($('<div class="nf-error-msg date-error">' + 'Last date should be after first date.' + '</div>'));
					} else {
						$(errorElements.slice(2,4)).each(function() {
							$(this).find('.date-error').remove();
						});
					}
				}
			}
		}
	});
});
